import React, { useState, useEffect, useRef } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

/**
 * Спеціальний компонент для справжнього Lazy Load.
 * Він рендерить GatsbyImage тільки тоді, коли блок з'являється у viewport.
 */
const LazyGatsbyImage = ({ image, alt, title, className, rootMargin = "0px", ...props }) => {
    const [isVisible, setIsVisible] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        // Якщо зображення не передано, нічого не робимо
        if (!image) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    // Після того, як блок став видимим, припиняємо спостереження
                    if (containerRef.current) {
                        observer.unobserve(containerRef.current);
                    }
                }
            },
            {
                rootMargin: rootMargin, // Починаємо завантаження заздалегідь
                threshold: 0.01,
            }
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }, [image, rootMargin]);

    return (
        <div ref={containerRef} className={className} style={{ width: '100%', height: '100%', position: 'relative' }}>
            {isVisible && image ? (
                <GatsbyImage
                    image={getImage(image)}
                    alt={alt}
                    title={title}
                    className={className}
                    loading="eager" // Використовуємо eager, бо ми самі контролюємо момент появи в DOM
                    {...props}
                />
            ) : (
                /* Плейсхолдер, щоб блок не був нульової висоти до появи */
                image?.placeholder?.fallback ? (
                    <img src={image?.placeholder?.fallback} alt=""/>
                    ) : ''
            )}
        </div>
    );
};

export default LazyGatsbyImage;
